import React from "react";

const VanRentalTable = ({ title, description, intro, columns, rows, notes, compact = false, background }) => {
  return (
    <section className="vr-table-section" style={background ? { background } : undefined}>
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>

        {intro && intro.length > 0 && (
          <div
            className="vr-table-intro"
            data-aos="fade-up"
            data-aos-once="true"
          >
            {intro.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        )}

        <div
          className={`table-responsive${compact ? " vr-table-compact" : ""}`}
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          <table className="vr-table">
            <thead>
              <tr>
                {columns.map((col, i) => (
                  <th key={i}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => (
                    <td key={j}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {notes && notes.length > 0 && (
          <div
            className={`vr-table-notes${compact ? " vr-table-compact" : ""}`}
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-once="true"
          >
            {notes.map((note, i) => (
              <p key={i} className="vr-table-note">{note}</p>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default VanRentalTable;
